































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import LayerLegendImage from '@/components/plugins/legend/LayerLegendImage.vue';
import VectorLegend from '@/components/plugins/legend/VectorLegend.vue';
import LayerConfig from '@/models/map-context/LayerConfig';
import Component from 'vue-class-component';
import BaseComponent from '../../BaseComponent';

@Component<LayerLegend>({
  props: {
    layer: LayerConfig,
  },
  components: {
    LayerLegendImage,
    VectorLegend,
  },
})
export default class LayerLegend extends BaseComponent {
  layer!:LayerConfig;
}
